import React, { useState, Context, ReactElement, Component } from "react";

export interface dashboard_item {
  id: number,
  uid: string,
  title: string,
  uri: string,
  type: string,
  tags: string[],
  isStarred: boolean,
  folderId?: number,
  folderUid?: string,
  folderTitle?: string,
  folderUrl?: string,
  url?: string
};

const DashboardContext: Context<[dashboard_item[], React.Dispatch<React.SetStateAction<dashboard_item[]>>]> = React.createContext<[dashboard_item[], React.Dispatch<React.SetStateAction<dashboard_item[]>>]>([[] as unknown as dashboard_item[], (_value: any) => { }]);

const DashboardProvider: (props: any) => ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)> | null => {
  const [dashboards, set_dashboards] = useState([] as unknown as dashboard_item[]);
  return (
    <DashboardContext.Provider value={[dashboards, set_dashboards]}>
      {props.children}
    </DashboardContext.Provider>
  )
}

export { DashboardContext, DashboardProvider };